// hooks
import { useHistory, useLocation } from 'react-router-dom'
import { MountpointMap } from 'api'
import { useToken } from 'App'
import useStyles from '../../styles'
// components
import { Tooltip } from 'react-leaflet'
import MountpointMarker from './MountpointMarker'
import { useEffect, useState } from 'react'
import L from 'leaflet'

interface Props {
  mountpoints: MountpointMap[]
  onClick: (latlng: L.LatLng) => void
  mountpointsClusterRef: React.RefObject<L.MarkerClusterGroup>
}
const MountpointsLayer = ({
  mountpoints,
  onClick,
  mountpointsClusterRef,
}: Props) => {
  const classes = useStyles()

  const { pathname } = useLocation()
  const { push } = useHistory()

  const { ut: userRole, c_id: userId } = useToken()

  const [latLng, setLatLng] = useState<L.LatLngExpression>()

  // const getMarkerColor = (mountpoint: MountpointMap) => {
  //   let color = '#499e22'

  //   // if (mountpoint.coord_alert) color = '#e74615'
  //   if (mountpoint.auto_mountpoint) color = '#266bc6'
  //   else if (mountpoint.inactive) color = '#5F6368'
  //   else if (!mountpoint.connected) color = '#c62626'
  //   else if (mountpoint.unstable) color = '#bbb919'

  //   return color
  // }

  const getMarkerColor = (mountpoint: MountpointMap) => {
    let color = '#499e22'

    if (!mountpoint.connected) color = '#c62626'
    else if (mountpoint.auto_mountpoint) color = '#266bc6'
    else if (mountpoint.inactive) color = '#5F6368'
    else if (mountpoint.unstable) color = '#bbb919'

    return color
  }

  useEffect(() => {
    const regex = /^\/mountpoint\/(\d+)\/info$/

    if (regex.test(pathname) && latLng) {
      const clusterGroup = mountpointsClusterRef.current

      const layer = clusterGroup?.getLayers().find((layer) => {
        if (layer instanceof L.Marker) {
          const layerLatLng = layer.getLatLng()
          return layerLatLng.equals(latLng)
        }
      })

      if (layer) {
        clusterGroup?.zoomToShowLayer(layer, () => {
          layer.openPopup()
        })
      }
    }

    // if (pathname)
  }, [pathname, latLng])

  return (
    <>
      {mountpoints?.map((mountpoint) => (
        <MountpointMarker
          position={[mountpoint.latitude, mountpoint.longitude]}
          eventHandlers={{
            click: ({ latlng }) => {
              if (
                (userRole === 'regular' && mountpoint.auto_userid !== userId) ||
                /measurement/i.test(pathname)
              ) {
                onClick(latlng)
                return
              }

              setLatLng([mountpoint.latitude, mountpoint.longitude])
              push(`/mountpoint/${mountpoint.id}/info`)
            },
            add: (e) => {
              e.target.mountpointId = mountpoint.id
            },
          }}
          coordAlert={mountpoint.coord_alert}
          color={getMarkerColor(mountpoint)}
          key={mountpoint.id}
        >
          <Tooltip
            direction="top"
            permanent
            className={classes.mountpointTooltip}
          >
            {mountpoint.name?.length <= 4
              ? mountpoint.name
              : `..${mountpoint.name?.slice(0, 4)}`}
          </Tooltip>
        </MountpointMarker>
      ))}
    </>
  )
}

export default MountpointsLayer
